var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "o"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6667 0.84375H6.33333C3.03125 0.84375 0.34375 3.53125 0.34375 6.83333V15.1667C0.34375 18.4688 3.03125 21.1562 6.33333 21.1562H14.6667C17.9688 21.1562 20.6562 18.4688 20.6562 15.1667V6.83333C20.6562 3.53125 17.9688 0.84375 14.6667 0.84375ZM9.94531 10.2474C10.1016 10.4036 10.2995 10.4766 10.4974 10.4766C10.6953 10.4766 10.8932 10.4036 11.0495 10.2474L15.2161 6.08073C15.5182 5.77865 15.5182 5.27865 15.2161 4.97656C14.9141 4.67448 14.4141 4.67448 14.112 4.97656L10.5 8.39329L6.88281 4.97656C6.58073 4.67448 6.08073 4.67448 5.77865 4.97656C5.47656 5.27865 5.47656 5.77864 5.77865 6.08073L9.94531 10.2474ZM10.4974 12.0417C10.6953 12.0417 10.8932 12.1146 11.0495 12.2708L15.2161 16.4375C15.5182 16.7396 15.5182 17.2396 15.2161 17.5417C14.9141 17.8437 14.4141 17.8437 14.112 17.5417L10.4948 14.1249L6.88281 17.5417C6.58073 17.8437 6.08073 17.8437 5.77865 17.5417C5.47656 17.2396 5.47656 16.7396 5.77865 16.4375L9.94531 12.2708C10.1016 12.1146 10.2995 12.0417 10.4974 12.0417Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandedIcon);
export default __webpack_public_path__ + "static/media/expanded-icon.be5a332604e0c708a050eeb2a41cd9a9.svg";
export { ForwardRef as ReactComponent };